<template>
    <Poptip placement="bottom" word-wrap=true width="225" v-model="isShow">
        <div :style="{'border': bColor}" class="my-box" style="margin-top: 2px;">
            <Icon class="icon" style="float:right;margin-top:8px" type="arrow-down-b"></Icon>
            <span v-if="isTime">请选择日期</span>
            <div v-else style="overflow: hidden;white-space: nowrap; width:217px" >
                <span v-for="(item,index) in numData">
                    <span class="num-box" v-if="item.isChecked" @click.stop="delNum(index)">
                        {{item.number}}
                        <Icon class="close" type="close-round" style="margin-top: 8px;"></Icon>
                    </span>
                </span>
                
            </div>
        </div>
        <div class="days-title" slot="title">
            <span>选择自定义日期</span>
        </div>
        <div  slot="content" height="auto">
            <Row>
                <Col span="24" > 
                    <div style=" width:100%;word-break:break-all;word-wrap:break-word;white-space: pre-wrap; padding-bottom:10px;margin-bottom: 10px;border-bottom: 1px solid #eee;">
                        <Row>
                            <Col class="days-content-item" span='4' v-for="(item,key) in this.numData" :key=key>
                                <div @click="switchDay(key)" :class="{'active': item.isChecked}">{{item.number}}</div>
                            </Col>
                        </Row> 
                    </div> 
                </Col>
            </Row> 
            <Row>
                <Col span="24" >
                    <Button size="small" class="days-button" type="primary" @click="isShow = false">确认</Button>
                    <Button size="small" class="days-button" type="ghost"  @click="clear" style="margin-right:7px;">清空</Button> 
                </Col>
            </Row>
        </div>
    </Poptip>
</template>

<script>
// right-start右下
import province from '../../libs/area.json'
// right右中
export default {
  
    props: {
        bColor:{
            type: String,
            default: '1px solid #dddee1'
        },
        isArr:{
            type: Array,
            default: []
        }
    },
    data() {
        return {
            numData:[],
            isShow: false,
        }
    },
    computed:{
        isTime(){
            let flag = true
            this.numData.map(item=>{
                if(item.isChecked == true){
                    flag = false
                }
            })
            return flag
        }
    },
    watch:{
        isArr(val,oldVal){
            this.numData.forEach(item=>{
                item.isChecked = false
            })
            setTimeout(()=>{
                if(val.lenght != 0){
                    this.numData.forEach((item,key)=>{
                        val.forEach((value,index)=>{
                            if(key+1 == value){
                                item.isChecked = true
                            }
                        })
                    })
                }
            },200)
        }
    },
    methods: {
        switchDay(key){
            if(this.numData[key].isChecked == false){
                this.numData[key].isChecked = true
            }else{
                this.numData[key].isChecked = false
            }
            this.$emit('handleClick',this.numData)
        },
        delNum(key){
            this.numData[key].isChecked = false
            this.$emit('handleClick',this.numData)
        },
        clear(){
            this.numData.map(item=>{
                item.isChecked = false
            })
            this.$emit('handleClick',this.numData)
        }
    },
    mounted() {
        for(let i=0;i<31;i++){
            this.numData.push({number:i+1,isChecked:false})
        }
        if(this.isArr.lenght != 0){
            this.numData.forEach((item,key)=>{
                this.isArr.forEach((value,index)=>{
                    if(key+1 == value){
                        item.isChecked = true
                    }
                })
            })
        }
    }
}

</script>

<style>
    .days-title{
        text-align: center;
        height: 30px;
        font-size: 14px;
        line-height: 30px;
    }
    .days-content-item{
        text-align: center;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        margin: 2px 0;
        cursor: pointer;
        font-size: 14px;
    }
    .active,.days-content-item:hover div{
        width: 80%;
        background: #81A7D9;
        color: #fff;
        margin: 0 auto;
        border-radius: 4px;
    }
    .days-button{
        float: right;
        display: block;
    }
    .num-box{
        height: 24px;
        line-height: 22px;
        color: #ccc;
        padding: 2px 10px 2px 10px;
        margin: 3px 4px 3px 0;
        border: 1px solid #e9eaec;
        border-radius: 3px;
        background: #f7f7f7;
    }
    .num-box:hover{
        color: #999;
        cursor: pointer;
    }
    .close{
        font-size: 12px;
        color: #ccc;
    }
    .num-box:hover .close{
        color: #f16b6b
    }
    .my-box{
        width: 250px;
        height: 28px;
        line-height: 28px;
        border-radius: 2px;
        padding: 0 10px;
        color: rgb(187,190,196)
    }
    .my-box:hover{
        cursor: text
    }
    .my-box:hover .icon{
        cursor: default
    }
</style>


// WEBPACK FOOTER //
// src/views/main-components/days.vue